module.exports = __webpack_public_path__ + "img/coinbankC29.ba68c7e1.jpg";